import React from 'react';
import { useLocation } from 'react-router-dom';

import AIChatButton from './AIChatButton';


// These pages already mount the launcher with live form/workflow context.
const CONTEXTUAL_AGENT_PATHS = new Set([
  '/affordability',
  '/compliance',
  '/large-purchase',
]);

const PAGE_CONTEXTS = {
  '/dashboard': {
    page: 'dashboard',
    purpose: 'Understand and act on the full current accounting picture',
  },
  '/analytics': {
    page: 'analytics',
    purpose: 'Investigate trends and patterns across the accounting data',
  },
  '/analytics/categories': {
    page: 'category_insights',
    purpose: 'Investigate category history, balances, and allocation patterns',
  },
  '/analytics/accounts': {
    page: 'account_analytics',
    purpose: 'Investigate account-level history and financial position',
  },
  '/settings': {
    page: 'settings',
    purpose: 'Help with accounting preferences and application configuration',
  },
  '/split-templates': {
    page: 'split_templates',
    purpose: 'Understand and refine recurring allocation rules',
  },
  '/autopayments': {
    page: 'autopayments',
    purpose: 'Understand recurring commitments and their accounting impact',
  },
  '/believe-it-in': {
    page: 'projections',
    purpose: 'Explore projections against the current financial network',
  },
  '/tax-helper': {
    page: 'tax_helper',
    purpose: 'Discuss tax planning in the context of the current accounting data',
  },
};


export const globalAgentContext = (pathname) => {
  if (pathname.startsWith('/accounts/')) {
    return {
      page: 'account_detail',
      purpose: 'Understand this account in the context of the full financial network',
    };
  }
  return PAGE_CONTEXTS[pathname] || {
    page: 'general',
    purpose: 'Work conversationally with the current accounting data',
  };
};


function GlobalAgentChatLauncher() {
  const { pathname } = useLocation();
  const authenticated = Boolean(window.localStorage.getItem('access_token'));

  if (!authenticated || CONTEXTUAL_AGENT_PATHS.has(pathname)) {
    return null;
  }

  return <AIChatButton context={globalAgentContext(pathname)} agentic />;
}

export default GlobalAgentChatLauncher;
